import { ApprovalOperation } from '../types/ApprovalOperation';
export const maxNumberOfApprovers = 10;
export const shouldPrimaryButtonBeDisabled = (approvalOperation, note, approversCount) => {
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      return !approversCount || approversCount > maxNumberOfApprovers;
    case ApprovalOperation.CANCEL:
      return !note;
    case ApprovalOperation.REJECT:
      return !note;
    case ApprovalOperation.APPROVE:
    default:
      return false;
  }
};